import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import GroupDataService from "../../services/group-data-service/GroupDataService";
import { ISelectableObject } from "../../services/group-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseGroupContentsParameters = {
    groupID: number,
    objectType?: eLynxObjectTypeEnum,
    includeChildOrgs?: boolean,
    excludeDynamicDevices?: boolean,
    includeTanks?: boolean,
    excludeHidden?: boolean
} & BaseUseQueryParameters<ISelectableObject[] | undefined>;

export function useGroupContents({
    groupID,
    objectType,
    includeChildOrgs,
    excludeDynamicDevices,
    includeTanks,
    excludeHidden,
    enabled,
    onError,
    onSuccess,
}: UseGroupContentsParameters) {
    return useQuery<ISelectableObject[], RestError>(
        keys.contents(groupID),
        ({ signal }) => {
            return GroupDataService.getGroupContents(
                groupID, 
                objectType,
                includeChildOrgs,
                excludeDynamicDevices,
                includeTanks,
                excludeHidden,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity
        }
    );
}